export default "__VITE_ASSET__BpBxgEjr__"